const API = require("./api");

const getValueById = (id) => document.getElementById(id).value;

const showPreloadForm = (e) => {
  e.classList.toggle("preload");
};

const onHelpSubmit = (e) => {
  e.preventDefault();

  const $submitButton = e.target.querySelector(".btn");
  showPreloadForm($submitButton);

  const first_name = getValueById("help:firstName");
  const last_name = getValueById("help:lastName");
  const full_name = `${first_name && first_name} ${last_name && last_name}`;
  const email = getValueById("help:email").toLowerCase();
  const message = getValueById("help:message");

  if (!email || !full_name || !message) {
    showPreloadForm($submitButton);
    return false;
  }

  API.helpMessage({ type: "help", full_name, email, message })
    .then((res) => {
      if (res && res.errors) {
        document.getElementById("help:error").innerHTML =
          typeof res.errors === "string" ? res.errors : "Error occured, please contact the support";
      } else if (res) {
        alert("Success!");
      }
    })
    .finally(() => {
      showPreloadForm($submitButton);
      document.getElementById("help:form").reset();
    });
};

const onContactUsSubmit = (e) => {
  e.preventDefault();

  const $submitButton = e.target.querySelector(".btn");
  showPreloadForm($submitButton);

  const full_name = getValueById("contact:full_name");
  const email = getValueById("contact:email").toLowerCase();
  const message = getValueById("contact:message");

  if (!email || !full_name || !message) {
    showPreloadForm($submitButton);
    return false;
  }

  API.contactMessage({ type: "contact_us", full_name, email, message })
    .then((res) => {
      if (res && res.errors) {
        document.getElementById("contact:error").innerHTML =
          typeof res.errors === "string" ? res.errors : "Error occured, please contact the support";
      } else if (res) {
        alert("Success!");
      }
    })
    .finally(() => {
      showPreloadForm($submitButton);
      document.getElementById("contact:form").reset();
    });
};

if (document.getElementById("help:form"))
  document.getElementById("help:form").onsubmit = onHelpSubmit;
if (document.getElementById("contact:form"))
  document.getElementById("contact:form").onsubmit = onContactUsSubmit;
